import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { CreateUser } from '@/models/user.model'

export default {
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  data () {
    return {
      createUserBean: new CreateUser(),
      civilityValues: ['Sélectionner une valeur', 'M.', 'Mme', 'Melle'],
      selectedGroup: 'Sélectionner une valeur',
      selectedCivility: 'Sélectionner une valeur',
      selectedEntreprise: 'Sélectionner une valeur',
      possibleLocalGroups: this.$store.state.user.user.possibleGroupesList,
      blankGroup: {},
      validationMessage: [],
      entreprises: [],
      loadingEntreprises: false,
      isBoxEntreprisesDisplayed: false,
      creationError: false
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Création d\'un utilisateur'
    this.$store.state.filArianeMiddlePage = 'Liste des utilisateurs'
    this.$store.state.filArianeMiddleRouterLink = 'administration/user/list'
  },
  created () {
    this.blankGroup.groupeId = 0
    this.blankGroup.name = this.selectedGroup
    this.possibleLocalGroups[0] = this.blankGroup
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('user/generateLogin', this.createUserBean).then(
      response => {
        this.loading = false
        this.createUserBean.id = response.login
      },
      error => {
        this.loading = false
        this.errorMessage = error.response.data
      }
    )
  },
  methods: {
    createUser () {
      this.validationMessage = []
      this.creationError = false
      this.createUserBean.civilite = this.selectedCivility

      for (let index = 0; index < this.possibleLocalGroups.length; index++) {
        if (this.possibleLocalGroups[index].name === this.selectedGroup) {
          this.createUserBean.groupe = this.possibleLocalGroups[index]
        }
      }

      for (let index = 0; index < this.entreprises.length; index++) {
        if (this.entreprises[index].name === this.selectedEntreprise) {
          this.createUserBean.selectedEntreprise = this.entreprises[index]
        }
      }

      if (!this.createUserBean.codeAcces || this.createUserBean.codeAcces === '' || this.createUserBean.codeAcces.length !== 8) {
        if (this.createUserBean.codeAcces && this.createUserBean.codeAcces !== '' && this.createUserBean.codeAcces.length !== 8) {
          this.validationMessage[0] = 'Password length must be 8.'
        } else {
          this.validationMessage[0] = 'You must provide a value for Password.'
        }
      }
      if (!this.createUserBean.groupe || this.createUserBean.groupe === '' || this.createUserBean.groupe.name === 'Sélectionner une valeur') {
        this.validationMessage[1] = 'You must provide a value for Group.'
      }
      if (!this.createUserBean.civilite || this.createUserBean.civilite === '' || this.createUserBean.civilite === 'Sélectionner une valeur') {
        this.validationMessage[2] = 'You must provide a value for Civility.'
      }
      if (!this.createUserBean.prenom || this.createUserBean.prenom === '') {
        this.validationMessage[3] = 'You must provide a value for First Name.'
      }
      if (!this.createUserBean.nom || this.createUserBean.nom === '') {
        this.validationMessage[4] = 'You must provide a value for Last Name.'
      }
      if (!this.createUserBean.adresse || this.createUserBean.adresse === '') {
        this.validationMessage[5] = 'You must provide a value for Address.'
      }
      if (!this.createUserBean.codePostal || this.createUserBean.codePostal === '') {
        this.validationMessage[6] = 'You must provide a value for Postal code.'
      }
      if (!this.createUserBean.ville || this.createUserBean.ville === '') {
        this.validationMessage[7] = 'You must provide a value for Town.'
      }
      if (!this.createUserBean.pays || this.createUserBean.pays === '') {
        this.validationMessage[8] = 'You must provide a value for Country.'
      }
      if (!this.selectedEntreprise || this.selectedEntreprise === 'Sélectionner une valeur') {
        if (this.isBoxEntreprisesDisplayed) {
          this.validationMessage[9] = 'You must provide a value for Entreprise.'
        }
      } else {
        for (let index = 0; index < this.entreprises.length; index++) {
          if (!this.createUserBean.selectedEntreprise && this.entreprises[index].entityName === this.selectedEntreprise) {
            this.createUserBean.selectedEntreprise = this.entreprises[index]
          }
        }
      }

      if (!this.validationMessage.length) {
        this.createUserBean.loggedUserLogin = this.$store.state.user.user.login
        // Creation du user
        this.loading = true
        this.$store.dispatch('user/createUser', this.createUserBean).then(
          response => {
            this.loading = false
            // Si creation ok, on renvoit vers la page d'edition de ce user
            this.$router.push({ name: 'administration/user/view', params: { 'editedUser': response } })
          },
          error => {
            this.loading = false
            this.errorMessage = error.response.data
            this.creationError = true
          }
        )
      }
    },
    getEntreprisesAndLoginForGroupe () {
      for (let index = 0; index < this.possibleLocalGroups.length; index++) {
        if (this.possibleLocalGroups[index].name === this.selectedGroup && this.selectedGroup !== 'Sélectionner une valeur') {
          this.createUserBean.groupe = this.possibleLocalGroups[index]
        }
      }
      this.loadingEntreprises = true
      this.$store.dispatch('user/generateLogin', this.createUserBean).then(
        response => {
          this.loadingEntreprises = false
          this.createUserBean.id = response.login
          this.isBoxEntreprisesDisplayed = response.displayEntrepriseCheckbox

          if (response.entreprises && response.entreprises.length) {
            let blankEntreprise = {}
            blankEntreprise.entityName = 'Sélectionner une valeur'
            blankEntreprise.entityId = 0

            this.entreprises = [blankEntreprise, ...response.entreprises]
          }
        },
        error => {
          this.loadingEntreprises = false
          this.errorMessage = error.response.data
          this.creationError = true
        }
      )
    }
  }
}
